module.exports = __webpack_public_path__ + "media/images/logo_61-a6c2b8ce.jpg";